var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[(!_vm.chartLoading)?_c('div',[(this.datas.length === 0 && !_vm.datas.omr)?_c('no-data-available',{attrs:{"height":450}}):_c('div',[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)],1):_c('loading-graph')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }